import { UnitOfMeasureTypes } from '../enumerations/unit-of-measure-type';
import { IItemLookup } from '../interfaces/dtos/IItemLookup';
import { convertCurrency } from './currency-helper';

export const getProductListingPrice = (item: IItemLookup): string => {
  let formattedPrice = '';

  if (item.hasPrice) {
    const currencyCode = item.regularSalesUnitPrice?.price.currency;
    const quantity = item.regularSalesUnitPrice?.quantity ?? 1;

    const currencyFormattedPrice = convertCurrency(item.unitPrice ?? 0, currencyCode);
    formattedPrice = `${currencyFormattedPrice}`;
    if (item.unitsOfMeasure && item.unitsOfMeasure !== UnitOfMeasureTypes.Each) {
      formattedPrice += ` / ${quantity === 1 ? '' : quantity} ${item.unitsOfMeasure}`;
    } else if (quantity > 1) {
      formattedPrice += ` / ${quantity} ${UnitOfMeasureTypes.Each}`;
    }
  } else {
    formattedPrice = item.requiredPrice ? 'PriceQueryView_OpenPrice' : 'PriceQueryView_NoPrice';
  }
  return formattedPrice;
};
